// extracted by mini-css-extract-plugin
export default {"container":"balancePerMonthCard_container__MyTQP","points":"balancePerMonthCard_points__Bv+Iw","point":"balancePerMonthCard_point__AlLTX"};